import { render, staticRenderFns } from "./DispositionDispatch.vue?vue&type=template&id=594d0eb4"
import script from "./DispositionDispatch.vue?vue&type=script&lang=js"
export * from "./DispositionDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports